import { GameVars } from "../../GameVars";
import { GameManager } from "../../GameManager";
import { AudioManager } from "../../AudioManager";

    export class TeamButton extends Phaser.Group {

        public tournaments: string[];
        public currentTournament: string;

        private teamName: string;
        private buttonImage: Phaser.Image;
        private teamNameLabel: Phaser.Text;

        constructor(game: Phaser.Game, teamData: TeamData) {

            super(game, null, "team_button", false);

            this.scale.y = GameVars.scaleY;

            this.teamName = teamData.name;
            this.tournaments = teamData.tournaments;

            const nameButtonImage = "seleccion_" + GameVars.formatNumberForTextureAtlas(teamData.id);

            this.buttonImage = new Phaser.Image(this.game, 0, 0, "texture_atlas_5", nameButtonImage);
            this.buttonImage.alpha = .4;
            this.buttonImage.anchor.set(.5);
            this.add(this.buttonImage);

            this.teamNameLabel = new Phaser.Text(this.game,
                0, 53, teamData.name,  {font: "26px Ubuntu Condensed", fill: "#000000", align: "center"});
            this.teamNameLabel.scale.set(.8, 1);
            this.teamNameLabel.anchor.x = .5;
            this.teamNameLabel.alpha = .5;
            this.add(this.teamNameLabel);
        }

        public activate(): void {

            this.buttonImage.inputEnabled = true;

            this.buttonImage.events.onInputDown.add(this.onClickButton, this);
            this.buttonImage.events.onInputOver.add(this.onOver, this);
            this.buttonImage.events.onInputOut.add(this.onOut, this);

            this.teamNameLabel.alpha = 1;
            this.buttonImage.alpha = 1;
            this.buttonImage.scale.set(1.1);
        }

        private onOver(): void {

            this.buttonImage.scale.set(1.15);
        }

        private onOut(): void {

            this.buttonImage.scale.set(1);
        }

        private onClickButton(): void {

            GameManager.onTeamSelected(this.teamName);

            AudioManager.getInstance().playEffect("play");
        }
    }
